import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { tidEquipmentQaQueueService, tidEquipmentQueueService } from "services";
import { uiActions } from "store";
import { ErrorResponse, FetchDataType } from "types";

type UseTidEquipmentListQueryProps = {
	tab: string;
	fetchData: FetchDataType;
	isQa?: boolean;
};

const useTidEquipmentListQuery = ({
	tab,
	fetchData,
	isQa = false,
}: UseTidEquipmentListQueryProps) => {
	const dispatch = useDispatch();

	const { page, filters, sortBy } = fetchData;

	const service = isQa
		? tidEquipmentQaQueueService
		: tidEquipmentQueueService;

	return useQuery(
		[tab, page, filters, sortBy],
		() =>
			service.getList({
				tabName: tab,
				page,
				filters,
				sortBy,
			}),
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			retry: 0,
			cacheTime: 0,
		},
	);
};
export default useTidEquipmentListQuery;
